// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filter-pill_wrapper__1-KbA","pill":"filter-pill_pill__2j_sZ"};